import { actions } from "store/modal";

export const { initModal, destroyModal, toggleModal, setDataModal } = actions;
